import { render, staticRenderFns } from "./CreateSalarySpecificationDialog.vue?vue&type=template&id=c5d41608"
import script from "./CreateSalarySpecificationDialog.vue?vue&type=script&lang=js"
export * from "./CreateSalarySpecificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports